import { render, staticRenderFns } from "./ModuloAutorizacionPantalla.vue?vue&type=template&id=3c2f4c9e&"
import script from "./ModuloAutorizacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./ModuloAutorizacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports